module.exports = __webpack_public_path__ + "static/media/quick-setup.bcc3eae3.svg";